import { z } from 'zod';
import { zStringRequired } from '../../z';
import { phoneSchema } from '../shared/phone-fax';
import { applySignatureRefinement, signatureDetailsSchema } from '../shared/signature';
export const dencValidationSchema = z.object({
    id: z.string(),
    signedUserId: zStringRequired(),
    signedUserDate: zStringRequired(),
    data: z
        .object({
        serviceTypes: z.enum(['SN', 'PT', 'OT', 'ST', 'HHA', 'MSW', 'Others']).array().min(1, 'At least one service type is required'),
        serviceTypeOther: z.string().optional(),
        facts: z.string().min(1, 'Facts used to make this decision are required'),
        detailedExplanation: z.string().min(1, 'Detailed explanation is required'),
        specificPlanPolicy: z.string().optional(),
        contactPhone: phoneSchema,
        patientSigned: z.boolean().nullish(),
        signedDate: z.string().nullish(),
        signatureDetails: signatureDetailsSchema,
    })
        .superRefine((data, ctx) => {
        if (data.serviceTypes.includes('Others') && !data.serviceTypeOther?.trim()) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['serviceTypeOther'],
                message: 'Please specify the other service type',
            });
        }
        applySignatureRefinement(ctx, data);
    }),
});
